import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/DateRangePicker.css';

interface DateRangePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  onChange: (startDate: Date | null, endDate: Date | null) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({ startDate, endDate, onChange }) => {
  const handleStartDateChange = (date: Date | null) => {
    onChange(date, endDate);
  };

  const handleEndDateChange = (date: Date | null) => {
    onChange(startDate, date);
  };

  return (
    <div className="date-range-picker">
      <div className="date-picker-group">
        <label>Start:</label>
        <DatePicker
          selected={startDate}
          onChange={handleStartDateChange}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          maxDate={new Date()}
          dateFormat="yyyy-MM-dd"
          placeholderText="Select start date"
          className="date-picker-input"
        />
      </div>
      <div className="date-picker-group">
        <label>End:</label>
        <DatePicker
          selected={endDate}
          onChange={handleEndDateChange}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          maxDate={new Date()}
          dateFormat="yyyy-MM-dd"
          placeholderText="Select end date"
          className="date-picker-input"
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
